<template>
  <el-dialog
    :title="isSubDevice ? $t('common.componentHistory') : $t('common.deviceHistory')"
    :visible="visible"
    width="60%"
    center
    @close="handleDialogClose">
    <div class="deviceHistoryContainer">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="addr" :label="$t('common.address')"/>
        <el-table-column :label="$t('common.status')">
          <template slot-scope="scope">
            {{ deviceStatusVal(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column v-if="isSubDevice" prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
        <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
        <el-table-column :label="$t('common.updateTime')">
          <template slot-scope="scope">
            {{ scope.row.updateAt | toTimeFormatFilter }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </el-dialog>
</template>

<script>
import {deviceHistory} from '@/api/device';
import {defaultDeviceStatus, defaultSubDeviceStatus} from "@/utils/defines";
import {
  Pagination,
} from '@/components';

export default {
  name: "DeviceHistoryDialog",
  props: {
    deviceId: Number,
    visible: Boolean,
    isSubDevice: Boolean,
  },
  components: {
    Pagination,
  },
  data() {
    return {
      historyList: [],
      page: 1,
      perpage: 10,
      totalCount: 0,
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.deviceHistory();
      }
    }
  },
  computed: {
    displayData() {
      return this.historyList;
    },
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    onChangePage() {
      this.deviceHistory();
    },
    async deviceHistory() {
      const {
        page,
        perpage,
      } = this;
      try {
        const res = await deviceHistory({
          page: page,
          perpage: perpage,
          id: this.deviceId,
        });
        const {
          data,
        } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        this.historyList = data.record || [];
      } catch (e) {
        // do nothing.
      }
    },
    deviceStatusVal(row) {
      const {
        status,
      } = row;
      if (this.isSubDevice) {
        const subDeviceStatus = defaultSubDeviceStatus[String(status)];
        return subDeviceStatus ? subDeviceStatus.explain : status;
      }
      const deviceStatus = defaultDeviceStatus[String(status)];
      return deviceStatus ? deviceStatus.explain : status;
    },
  }
}
</script>

<style lang="less" scoped>
.deviceHistoryContainer {
  height: 50vh;
}
/deep/ .el-table__row {
  td:not(.is-hidden):last-child{
    right: 1px;
  }
}
</style>
